import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogIconNames, DialogContentType, DialogFooterType, Dialog, CUIText } from '@dotcom/crown-ui';
import { ActionButton } from './fragments/action-button';
import { CancelButton } from './fragments/cancel-button';
import { SystemFailureDialogProps } from './system-failure-dialog-types';

export const SystemFailureDialog = ({ actionButton, cancelButton, onClose, isOpen }: SystemFailureDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id={'system-failure-dialog'}
      isOpen={isOpen}
      onClose={onClose}
      closeButtonId={'close-button'}
      accentIcon={DialogIconNames.CardFeaturesBold}
      hasGrayBackground={true}
      type={DialogContentType.Modal}
      testId="system-failure-dialog"
      title="System Error"
      footerType={DialogFooterType.Cancel}
      disableDialogScroll={true}
      actionButton={<ActionButton click={actionButton} />}
      cancelButton={<CancelButton click={cancelButton} />}
    >
      <CUIText>{t('systemFailureDialog.message')}</CUIText>
    </Dialog>
  );
};
